<template>
  <div :photo="photo">
    <el-dialog
      class="avatar-uploader quying-dialog"
      title="上传照片"
      :visible.sync="visbility"
      width="446px"
      :before-close="handleClose"
      :close-on-click-modal="true"
      ref="editAvatar"
    >
      <div class="avatar-uploader-wrap">
        <!-- step1 -->
        <div
          class="avatar-uploader__choose avatar-uploader_left"
          v-show="!photo && !isSuccess"
        >
          <button class="avatar-uploader_left__btn" @click="handleClick">
            +选择图片
          </button>
          <p>只支持JPG,PNG,GIF,大小需大于1M小于5M</p>
          <input
            type="file"
            v-show="false"
            ref="fileinput"
            accept=".jpg, .jpeg, .png, .gif"
            @change="handleChange"
          />
        </div>
        <!-- step2 -->
        <div class="avatar-uploader__edit" v-show="photo || isSuccess">
          <div class="avatar-uploader_left avatar-uploader__edit-area">
            <vue-cropper
              ref="cropper"
              :img="cropper.img"
              :output-size="cropper.size"
              :output-type="cropper.outputType"
              :info="true"
              :full="cropper.full"
              :fixed="fixed"
              :high="cropper.high"
              :canScale="cropper.canScale"
              :can-move="cropper.canMove"
              :can-move-box="cropper.canMoveBox"
              :fixed-box="cropper.fixedBox"
              :center-box="cropper.centerBox"
              @real-time="realTime"
              :enlarge="cropper.enlarge"
              :fixed-number="cropper.fixedNumber"
              mode="cover"
            ></vue-cropper>
          </div>
          <input
            type="file"
            v-show="false"
            ref="fileinput"
            accept=".jpg, .jpeg, .png, .gif"
            @change="handleChange"
          />
          <el-checkbox
            class="avatar-uploader_left__btn avatar-uploader_left__checkbox"
            v-model="useAvatar"
            >同步到头像</el-checkbox
          >
          <button
            class="avatar-uploader_left__btn re-choose"
            @click="handleClick"
          >
            重新选择
          </button>
          <button class="avatar-uploader_left__btn" @click="rotateRight">
            旋转90°
          </button>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visbility = false" size="small">取 消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="summitAvata()"
          style="background-color:#4272AB;"
          v-trace-click="'n.3387.6052.0'"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { VueCropper } from "vue-cropper";
export default {
  data() {
    return {
      visbility: false,
      fixed: true,
      photo: "",
      cropper: {
        img: "",
        size: 1,
        full: false,
        outputType: "png",
        canMove: true,
        fixedBox: true,
        canMoveBox: true,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 300,
        autoCropHeight: 400,
        fixedNumber: [300, 400],
        centerBox: false,
        canScale: false,
        high: true
      },
      isSuccess: false,
      cropImgBlob: null,
      previews: {},
      useAvatar: false
      // step: 2
    };
  },
  components: {
    VueCropper
  },
  methods: {
    /*
     * fixMe: 检查文件类型
     *
     * input标签的accept属性可能有兼容性问题（暂不解决）
     * 参阅 https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file
     */
    /* -------------------------------头像上传组件start-------------------------------- */
    preventDefault(e) {
      e.preventDefault();
      return false;
    },
    // 点击按钮打开文件资源窗口
    handleClick(e) {
      if (e.target !== this.$refs.fileinput) {
        e.preventDefault();
        if (document.activeElement !== this.$refs) {
          this.$refs.fileinput.click();
        }
      }
    },
    // 检测选择的文件是否合适
    checkFile(file) {
      console.log("checkFile", file);
      // 仅限图片
      if (!file) return false;
      if (file.type.indexOf("image") === -1) {
        this.$message({
          message: "请选择合适的文件类型",
          type: "warning"
        });
        return false;
      }
      // 超出大小
      if (file.size / 1024 < 1024) {
        this.$message({
          message: "图片大小小于1MB，请重新选择",
          type: "warning"
        });
        return false;
      } else if (file.size / 1024 > 1024 * 5) {
        this.$message({
          message: "图片大小大于5MB，请重新选择",
          type: "warning"
        });
        return false;
      }
      this.cropImgBlob = file;
      return true;
    },
    // 设置图片源
    setSourceImg(file) {
      let fr = new FileReader();
      fr.onload = (e)=> {
        this.cropper.img = fr.result;
      };
      fr.readAsDataURL(file);
    },
    // 触发input框的change事件选择图片
    handleChange(e) {
      e.preventDefault();
      let files = e.target.files || e.dataTransfer.files;
      this.$refs.cropper && (this.$refs.cropper.rotate = 0); // 重置要裁剪的图片的旋转角度
      this.isSuccess = true;
      if (this.checkFile(files[0])) {
        this.setSourceImg(files[0]);
      }
    },
    // 点击向右旋转
    rotateRight(e) {
      e.preventDefault();
      this.$refs.cropper.rotateRight();
    },
    // 点击关闭弹窗
    handleClose() {
      this.cropper.img = "";
      this.visbility = false;
    },
    // 实时预览
    realTime(data) {
      this.previews = data;
    },
    // 点击确定上传裁剪完的头像图片（blob类型）
    summitAvata() {
      this.$refs.cropper.getCropBlob(data => {
        // this.cropImgBlob = data;
        let formdata = new FormData(); // 创建form对象
        formdata.append(
          "file",
          this.cropImgBlob,
          "/Documents/0EF3BFAA-A61D-494A-94BD-039C77D3F3EF.png"
        );
        formdata.append("use_avatar", Number(this.useAvatar));
        const loading = this.$loading({
          lock: true,
          text: "工卡照片上传中。。。",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        _api.personal
          .uploadCard(formdata)
          .then(res => {
            loading.close();
            this.useAvatar && this.$store.dispatch("getInfo");
            this.$message({
              message: "工卡图片上传成功",
              type: "success"
            });
            this.$emit("uploadSuccess");
          })
          .catch(err => {
            loading.close();
          });
        this.visbility = false;
      });
    }
  },
  watch: {
    // 实时预览
    previews: function() {
      this.$refs.cropper.getCropData(data => {
        this.previews.url = data;
      });
    },

    visbility(val) {
      this.$emit("update:dialogVisible", val);
    },
    dialogVisible(val) {
      this.visbility = val;
    }
  },
  activated() {
    this.isSuccess = false;
  }
};
</script>

<style lang="scss" scoped>
.avatar-uploader {
  &-wrap {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 100%;
  }
  &_left {
    width: 360px;
    height: 436px;
    font-size: 13px;
    color: #999999;
    position: relative;
    background: #f8f8f8;
    &__btn {
      cursor: pointer;
      color: #999999;
      width: 88px;
      height: 34px;
      background: #fff;
      outline: none;
      border-radius: 82px;
    }
  }
  &__choose {
    margin: 0 auto;
    p {
      margin-top: 60%;
      width: 100%;
      text-align: center;
    }
    button {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -120%);
    }
  }
  &__edit {
    margin: 0 auto;
    &-area {
      overflow: hidden;
      &-img {
        object-fit: cover;
      }
    }
    .avatar-uploader_left__btn {
      float: right;
      margin-top: 20px;
      width: auto;
      height: 20px;
      padding: 0 12px;
      &:nth-of-type(1) {
        color: #4272ab;
      }
    }

    .avatar-uploader_left__checkbox /deep/ {
      float: left;
      color: #333333 !important;

      .el-checkbox__inner {
        border-radius: 50% !important;
      }
    }

    .re-choose {
      position: relative;
      &::before {
        content: "";
        position: absolute;
        top: 5px;
        left: 0;
        width: 2px;
        height: 10px;
        background: rgba(153, 153, 153, 1);
      }
    }
  }
  $top: 20px;
}
</style>

<style lang="scss">
// 小的弹窗用el-messagebox，大弹窗有复杂交互的用el-dialog
// 弹窗（el-dialog）样式修改
.el-message {
  z-index: 2020 !important;
}
.el-image-viewer__close {
  top: 0 !important;
  right: 400px !important;
}
.quying-dialog {
  .el-dialog__header {
    padding: 30px 20px 20px;
    padding-bottom: 10px;
  }
  .el-dialog__body {
    padding: 5px 20px;
    overflow: hidden;
  }
  .el-dialog__headerbtn .el-dialog__close {
    font-size: 20px;
  }
  .el-dialog__footer {
    text-align: center;
    padding: 20px 20px;
    .el-button {
      width: 90px;
      margin-right: 30px;
    }
  }
}
</style>
